/* src/app/job-signoff-artic/pages/job-signoff-artic-edit/job-signoff-artic-edit.component.scss */
/*# sourceMappingURL=job-signoff-artic-edit.component.css.map */
